module.exports = __webpack_public_path__ + "img/expozitie-de-arta-fotografica.7034c534.jpg";